import React from 'react';
import classes from "./MyAccountPage.module.css";
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeUserDetails } from '../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useEffect } from 'react';
import { SubscriptionLogsApi, unsubscribeAPI } from '../http/http';

const MyAccountPage = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [subscriptionLogs, setSubscriptionLogs] = useState(null);
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    const getLogs = async () => {
        SubscriptionLogsApi(userDetails?.msisdn).then((response) => {
            setLoading(false);
            console.log(response, 'd');
            setSubscriptionLogs(response?.data?.subscriptionData);
        }).catch(err => {
            setLoading(false);
            console.log("error----", err);
            toast.error("Something Went Wrong!");
        })
    }

    useEffect(() => {
        if (userDetails?.msisdn) {
            getLogs();
        }
        else {
            navigate("/");
        }
    }, []);

    const handleDeactivate = async () => {
        try {
            setDeactivateLoading(true);
            const response = await unsubscribeAPI(userDetails?.msisdn);
            setDeactivateLoading(false);

            dispatch(removeUserDetails());
            navigate("/");
            toast.success("Unsubscribed Successfully!");
        } catch (error) {
            setDeactivateLoading(false);
            toast.error("Something Went Wrong! Try Again!");
        }
    }

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <FaArrowLeft className="back-icon" style={{ color: "#1C1F26" }} onClick={() => navigate("/home")} />
                    <div className={classes.logo_container}
                        onClick={() => {
                            navigate("/home");
                        }}
                    >
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>
                </nav>
            </header>

            {loading ? <p>Loading! Please Wait...</p> : (
                <>
                    <div className={classes.section}>
                        <h2 className={classes.sectionHeading}>Subscription Details</h2>

                        <div className={classes.cardList}>
                            {subscriptionLogs?.map((log, index) => (
                                <div key={index} className={classes.card}>
                                    <p><strong>Pack:</strong> {log?.pack_type}</p>
                                    <p><strong>Amount:</strong> {log?.amount}</p>
                                    <p><strong>Subscribed On:</strong> {new Date(log?.subDateTime).toLocaleDateString()}</p>
                                    <p><strong>Next Billing Date:</strong> {new Date(log?.nextBilledDateTime).toLocaleDateString()}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}

               <div className={classes.actionButtons}>
                    <button type="button" className={classes.deactivate_button}
                        onClick={() => setShowModal(true)}
                    >
                        Unsubscribe
                    </button>
                </div>

            {showModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modal}>
                        <h3>Confirm Unsubscription</h3>
                        <p>Are you sure you want to unsubscribe from service?</p>
                        <div className={classes.modalActions}>
                            <button onClick={() => setShowModal(false)}
                                disabled={deactivateLoading}
                            >Cancel</button>
                            <button onClick={handleDeactivate}
                                disabled={deactivateLoading}
                                className={classes.confirmButton}>
                                {deactivateLoading ? "Please Wait..." : "Unsubscribe"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </main>
    )
}

export default MyAccountPage